import { ProjectTemplateModel } from 'api/dto/ProjectTemplate.dto';
import { Resource } from 'model/Resource';

export const STORE_NAME = 'createFromTemplate';

export namespace CreateFromTemplateState {
  export type Domain = {
    libraryResource: Resource<ProjectTemplateModel[]>;
    previewResource: Resource<ProjectTemplateModel>;
  };

  export const INITIAL_DOMAIN: Domain = {
    libraryResource: Resource.createPendingResource(),
    previewResource: Resource.createPendingResource(),
  };
}
